define( [
	"../../core",
	"../../selector"
], function( jQuery ) {
	"use strict";

	return jQuery.expr.match.needsContext;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/traversing/var/rneedsContext.js
// module id = 460
// module chunks = 17 22 23